import { useTheme } from '@emotion/react';

import CheckIcon from '@app/assets/icons/CheckIcon';
import WarningIcon from '@app/components/Alert/WarningIcon';
import { rem } from '@app/styles/theme/layout';

import { LicenseCardVariant } from './LicenseCard.constants';

export const CheckmarkIcon = ({
  type = LicenseCardVariant.Default,
}: {
  type: LicenseCardVariant;
}) => {
  const theme = useTheme();

  switch (type) {
    case LicenseCardVariant.Recommendation:
      return <CheckIcon fill={theme.colors.acidGreen} />;
    case LicenseCardVariant.Unqualified:
      return <WarningIcon fill={theme.colors.darkOrange} width={rem(20)} />;
    default:
      return <CheckIcon fill={theme.colors.lightBlue} />;
  }
};
